/* BIA motion — scroll reveals. Fails safe: if anything goes wrong, or if the
   viewer prefers reduced motion, every element is left fully visible. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function showAll(els) { for (var i = 0; i < els.length; i++) els[i].classList.add('is-in'); }

  function init() {
    var els = document.querySelectorAll('.bp__fig, [data-bia-reveal]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { showAll(els); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = Math.min(i, 6) * 55;
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    for (var i = 0; i < els.length; i++) io.observe(els[i]);

    /* Safety net: anything still hidden after 2.5s is revealed regardless. */
    setTimeout(function () { showAll(document.querySelectorAll('.bp__fig:not(.is-in), [data-bia-reveal]:not(.is-in)')); }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
